import { useCatalog } from '../../contexts/CatalogContext';
import { rating } from '../../core/format/currency';
import { HomeHero } from './HomeHero';
import { HomeManifest } from './HomeManifest';
import { ConcernFinder } from './ConcernFinder';
import { HomeShelf } from './HomeShelf';
import { HomeStory } from './HomeStory';
import { HomeReviews } from './HomeReviews';
import { HomeProtocols } from './HomeProtocols';
import { HomeJournal } from './HomeJournal';
import { HomeVisit } from './HomeVisit';
import { HOME_SHELF, heroProducts, homeBestsellers } from './homeRules';

/**
 * De homepage (docs/VORMGEVING.md §3). Eén verhaal: salon én thuis, door één specialist.
 * Ritme van tonen, elk blok één taak:
 *
 * 1. opening met de twee deuren (sand): wie, wat, waar naartoe
 * 2. waar ik voor sta (blush): waarom salon en producten bij elkaar horen
 * 3. klachtenkiezer (shell): per klacht thuis én salon naast elkaar
 * 4. salonfavorieten (sand): de plank
 * 5. werkwijze als ritueel (salie)
 * 6. reviews (sand)
 * 7. protocollen (shell)
 * 8. journal (sand)
 * 9. kom langs (blush), daarna de footer (klei)
 */
export function Home() {
  const {
    products,
    shopRating
  } = useCatalog();
  const shelf = homeBestsellers(products, HOME_SHELF);
  const featured = heroProducts(products);
  return <>
      <HomeHero reviewCount={shopRating.count} avgRating={rating(shopRating.average)} featured={featured} data-id="element-7352" data-mp="g19ag1nkbdzk" />
      <HomeManifest data-id="element-7353" data-mp="3ogt0yswumiax" />
      <ConcernFinder data-id="element-7354" data-mp="3og9m5l2hwa14" />
      {shelf.length > 0 && <HomeShelf products={shelf} total={products.length} data-id="element-7355" data-mp="3oj5hr2qvemme" />}
      <HomeStory data-id="element-7356" data-mp="3jizwc4b71wcr" />
      <HomeReviews data-id="element-7357" data-mp="3jjj62xqoxefp" />
      <HomeProtocols data-id="element-7358" data-mp="3jk2pyjzwicwd" />
      <HomeJournal data-id="element-7359" data-mp="1c3gas3l0dyj" />
      <HomeVisit data-id="element-7360" data-mp="1clkqc0edyhj" />
    </>;
}